import PricingPage from '../features/pricing';
export default PricingPage;
